import { Button, Card, CardContent, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { ChangeEvent, useState } from 'react';
import ProjetosHeader from '../components/projetoComponets/ProjetosHeader';
import { EnumColors } from '../enum/EnumColors';

const useStyle = makeStyles((theme) => ({
    headerMenu: {
        backgroundColor: EnumColors.YELLOW,
        color: EnumColors.PURPLE_MIDLE,
        fontSize: "20px"
    },
    gridMargin: {
        marginTop: "15px"
    },
    gridPaddingBottom: {
        paddingBottom: "15px"
    },
    headerBt: {
        zIndex: 100,
        padding: "10px 10px 10px",
        background: EnumColors.YELLOW,
        borderRadius: "10px",
        margin: theme.spacing(2),
        '&:hover': {
            backgroundColor: EnumColors.PURPLE_MIDLE,
            color: EnumColors.WHITE
        },
        color: EnumColors.WHITE
    }
}));

const WhatsappComponent: React.FC = () => {
    const classes = useStyle();

    const wpp = {
        number: null,
    };

    const [currentWpp, setCurrentWpp] = useState<any>(wpp);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setCurrentWpp({ ...currentWpp, [name]: value });
    };


    function openWpp() {
        var numberSend = 'https://api.whatsapp.com/send?phone=55' + currentWpp.numero
        window.open(numberSend, '_blank');
    }


    return (<>
        <ProjetosHeader />
        <Grid container
            direction="row"
            justifyContent="center"
            alignItems="center">
            <Grid item
                xs={12}>
                <Card  >
                    <CardContent>
                        <Typography variant="h3" component="h1" className={classes.gridPaddingBottom}>
                            Abrir numero no Whatsapp
                        </Typography>

                        <Grid item
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center" className={classes.gridMargin}>
                            <Typography variant="body1" component="p">
                                Numero: <TextField id="numero" name="numero" type="number" value={currentWpp.numero} onChange={handleInputChange} />
                            </Typography>
                            <Button size="small" onClick={openWpp} color="primary"
                                className={classes.headerBt}>Abrir</Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

    </>);
}
export default WhatsappComponent;